import ApiResourceManager from '../ApiResourceManager';

export default class ServiceContractsManager extends ApiResourceManager {
  get = () =>
    this.request({
      method: 'GET',
      url: '/service-contracts',
    });

  save = (data) =>
    this.request({
      method: 'POST',
      url: '/service-contracts',
      data,
    });

  partialUpdate = (id, data) =>
    this.request({
      method: 'PATCH',
      url: `/service-contracts/${id}`,
      data,
    });

  switchToAnnual = (id, data) =>
    this.request({
      method: 'POST',
      url: `/service-contracts/${id}/switch-to-annual`,
      data,
    });

  sign = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/service-contracts/${id}/sign`,
      data,
    });

  preview = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/service-contracts/${id}/preview`,
      responseType: 'blob',
      data,
    });

  initSign = (id, data) =>
    this.request({
      method: 'POST',
      url: `/service-contracts/${id}/init-sign`,
      data,
    });

  getSignatureLink = (id, params) =>
    this.request({
      method: 'GET',
      url: `/service-contracts/${id}/signature-link`,
      params,
    });

  startInPersonSigning = (id) =>
    this.request({
      method: 'POST',
      url: `/service-contracts/${id}/in-person-signing`,
    });

  createPaymentLink = (contractId, data) =>
    this.request({
      method: 'post',
      url: `/service-contracts/${contractId}/payments`,
      data,
    });

  previewTemplate = (data) =>
    this.request({
      method: 'POST',
      url: '/service-contract-template/preview',
      responseType: 'blob',
      data,
    });
}
